const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import EventManager from "../../../../manager/event_manager"
import ModuleManager from "../../../../framework/core/module_manager";
import UserManager from "../../../../manager/user_manager";
import MailItem from "./mail_item";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import { ScrollView } from "../../../../framework/tools/scrollview/scrollview";
import LanguageManager from "../../../../manager/language_manager";
import Utility from "../../../../utility/utility";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import AppData from "../../../public/const/app_data";
import GameUtil from "../../../../utility/game_util";

@ccclass
export default class MailView extends ViewBase {

    @property(cc.Node)
    nodeNonePanel: cc.Node = null

    @property(cc.Node)
    nodeMailPanel: cc.Node = null

    @property(MailItem)
    prefab_mailItem: MailItem = null

    @property(cc.Node)
    prefab_awardItem: cc.Node = null

    @property(cc.ScrollView)
    maiListScrollView: cc.ScrollView = null

    @property(cc.Node)
    mailListView: cc.Node = null

    @property(cc.Node)
    nodeMailListConent: cc.Node = null

    @property(cc.Label)
    labelTitle_detail: cc.Label = null

    @property(cc.RichText)
    labelContent_detail: cc.RichText = null

    @property(SpriteFrameHolder)
    iconSpriteFrameHolder: SpriteFrameHolder = null

    @property(cc.Node)
    nodeGetAttachBtn: cc.Node = null

    @property(cc.Button)
    buttonGetAllAttach: cc.Button = null

    @property(cc.Node)
    getAllAttachBtnBgNormal: cc.Node = null

    @property(cc.Node)
    getAllAttachBtnBgGray: cc.Node = null

    @property(cc.Label)
    labelAttachTitle: cc.Label = null

    @property(cc.Node)
    nodeDeleteBtn: cc.Node = null

    @property(cc.Node)
    nodeLinkBtn: cc.Node = null

    protected m_awardItemList: any[] = []
    protected m_mailListData: any

    protected m_lastSelectIndex: number = -1

    protected m_list: ListView = null

    onLoad(){
        let list: ListView = new ListView({
            scrollview: this.maiListScrollView,
            view: this.mailListView,
            content: this.nodeMailListConent,
            item_prefab: this.prefab_mailItem.node,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 5,
            gap_y: 4,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
        let self = this
        this.eventBind('click_mail_item', function(data){
            self.m_list.select_item(data._index)
        })
        this.labelAttachTitle.string = LanguageManager.t('public_mail_attach') + ':'
    }

    onShow(intentData?: any) {
        super.onShow(intentData)
    }

    showEmptyPanel(show: boolean){
        this.nodeNonePanel.active = !!show        
    }

    showMailPanel(show: boolean, data?){
        this.nodeMailPanel.active = !!show
        this.m_mailListData = data
        this.m_list.set_data(data)
        if(data && data.length > 0){
            this.m_list.scroll_to(0)
            this.m_list.select_item(0)
        }        

        this.refreshGetAllAttachBtn()
        if(!show){
            this.refreshDetailPanel(null)
        }
    }

    refreshDetailPanel(data){
        if(!data){
            this.labelTitle_detail.node.parent.active = false
            return
        }
        this.labelTitle_detail.node.parent.active = true
        this.labelTitle_detail.string = data.title
        this.labelContent_detail.string = data.content
        this.nodeLinkBtn.active = this.needShowLink(data)
        for (let index = 0; index < this.m_awardItemList.length; index++) {
            const element = this.m_awardItemList[index];
            element.root.active = false
        }
        this.nodeGetAttachBtn.active = !!(data.attachs && data.attachs.length > 0 && data.attachStatus == 1)        
        if(data.attachs && data.attachs.length > 0){
            for (let index = 0; index < data.attachs.length; index++) {
                const attach = data.attachs[index];
                if(this.m_awardItemList.length <= index){
                    this.m_awardItemList.push(this.cloneAwardItem(this.prefab_awardItem))
                }
                let holder = this.m_awardItemList[index]
                holder.data = attach
                let itemName = ''
                let iconSpriteFrame = null
                let iconSpriteFrame_gray = null
                let spriteFrameKey = ''
                if(attach.type == 5){
                    // itemName = LanguageManager.t('Public_Chip')
                    spriteFrameKey = 'chip'
                }else if(attach.type == 6){
                    // itemName = LanguageManager.t('Public_Mango')
                    spriteFrameKey = 'gold'
                }else if(attach.type == 100){
                    // itemName = LanguageManager.t('Public_DaiBi')
                    spriteFrameKey = 'daibi'
                }else if(attach.type == 10){
                    spriteFrameKey = attach.itemCode
                    itemName = attach.itemName
                }
                
                if(data.attachStatus == 2){
                    iconSpriteFrame = this.iconSpriteFrameHolder.getSpriteFrameByKey(spriteFrameKey + '_gray')
                    if(!iconSpriteFrame){
                        iconSpriteFrame = this.iconSpriteFrameHolder.getSpriteFrameByKey(spriteFrameKey)
                        if(iconSpriteFrame){
                            Utility.setGray(holder.sprite_icon)
                        }
                    }
                }else{
                    iconSpriteFrame = this.iconSpriteFrameHolder.getSpriteFrameByKey(spriteFrameKey)
                    Utility.resetGray(holder.sprite_icon)
                }
                
                if(iconSpriteFrame){
                    holder.sprite_icon.spriteFrame = iconSpriteFrame
                    // Utility.scaleSpriteToSize(holder.sprite_icon, iconSpriteFrame, 69)
                }else{
                    holder.sprite_icon.spriteFrame = iconSpriteFrame
                }
                
                holder.label_name.string = itemName
                holder.label_num.string = 'x' + GameUtil.currencyFormatting(attach.num)
                holder.label_num.node.color = data.attachStatus == 2? cc.Color.WHITE.fromHEX('717171'): cc.Color.WHITE.fromHEX('#AC4D04')
                holder.root.active = true
            }
            this.nodeDeleteBtn.active = data.attachStatus != 1
        }else{
            this.nodeDeleteBtn.active = true
        }
    }

    protected update_list_item(item: cc.Node, data: any, index: number){
        let mailItem = item.getComponent(MailItem)
        data._index = index
        mailItem.show(true, data)
    }

    refreshGetAllAttachBtn(){
        let allAttachGetted = true
        let mailList = this.m_mailListData
        for (let index = 0; index < mailList.length; index++) {
            let mailData = mailList[index]
            if(mailData.attachs && mailData.attachs.length > 0 && mailData.attachStatus == 1){
                allAttachGetted = false
                break
            }
        }
        this.buttonGetAllAttach.interactable = !allAttachGetted
        this.getAllAttachBtnBgNormal.active = !allAttachGetted
        this.getAllAttachBtnBgGray.active = !!allAttachGetted
    }

    refreshMailItem(data, index){
        this.m_list.refresh_item(index, data)
    }

    protected on_item_select(data: any, index: number){
        let lastIndex = this.m_lastSelectIndex
        if(lastIndex >= 0){
            let lastData = this.m_mailListData[lastIndex]
            if(lastData){
                lastData.selected = false
                this.refreshMailItem(lastData, lastIndex)
            }            
        } 
        data.selected = true  
        this.refreshMailItem(data, index)                     
        this.m_lastSelectIndex = index                
        this.refreshDetailPanel(data)
        this.eventDispatch('select_mail_item', data, index)
    }    

    private cloneAwardItem(prefab) {
        let item = cc.instantiate(prefab)
        item.parent = prefab.parent
        item.scale = 1
        let holder = {
            root: item,
            sprite_icon: cc.find('icon', item).getComponent(cc.Sprite),
            label_name: cc.find('name', item).getComponent(cc.Label),
            label_num: cc.find('num', item).getComponent(cc.Label),
        }
        return holder
    }

    protected needShowLink(data): boolean{
        let url = data.customeAppField
        if(!url || url == ''){
            return false
        }
        return true
    }
}
